<template>
  <div id="index">
    <el-container>
      <div class="rightSide" style="top: 0; left: 0">
        <el-header class="Large-Header">
          <img src="~/assets/img/Loginlogo.png" />
          <span>
            {{ translate["ACIoTMP"] }}
            <!-- <small>Air Compressor IoT Management Platform</small> -->
          </span>
          <div class="Large-language">
            <el-button
              @click="changeLanguage('zh')"
              round
              :class="activeLang == 'zh' ? 'selected' : ''"
              >简体中文</el-button
            >
            <el-button
              @click="changeLanguage('en')"
              round
              :class="activeLang == 'en' ? 'selected' : ''"
              >English</el-button
            >
            <el-button
              class="backHome"
              icon="el-icon-s-home"
              v-on:click="retHome()"
              ></el-button
            >
          </div>
        </el-header>
        <el-main class="index Large-index">
          <el-row>
            <el-col
              :xs="24"
              :sm="24"
              :md="24"
              :lg="24"
              style="position: relative"
            >
              <el-row>
                <el-col
                  :xs="24"
                  :sm="24"
                  :md="24"
                  :lg="24"
                  style="position: absolute; top: 0; left: 10px; right: 10px"
                >
                  <div class="homeConNoBG" style="overflow: hidden">
                    <!-- <h4 class="BoxTitle" style="margin-top: 11px">
                      {{ translate["ACDMap"] }}
                    </h4> -->
                    <div id="map" :style="mapHeight"></div>
                  </div>
                </el-col>

                <el-col :xs="24" :sm="24" :md="7" :lg="7">
                  <el-row>
                    <el-col :xs="24" :sm="24" :md="24" :lg="24">
                      <div class="homeCon homeConOpacity" :style="H1">
                        <h4 class="BoxTitle">
                          {{ translate["totalShipment"] }}
                          <strong class="fr">{{ totalShipmentCount }}</strong>
                        </h4>
                        <el-table :data="tableSend" :style="H1Table">
                          <el-table-column
                            prop="name"
                            label=" "
                            class-name="strong"
                            align="center"
                            min-width="60px"
                          >
                          </el-table-column>
                          <el-table-column
                            prop="Rotary"
                            label="Rotary"
                            align="center"
                            min-width="60px"
                          >
                            <template slot-scope="scope">
                              <el-tooltip  placement="right-start">
                                <div slot="content" style="margin-left:100px; min-width:250px; overflow: auto; margin:10px;;max-height: 60vh;">
                                    <el-table :data="classifyNumObj[scope.row.name]?.Rotary" stripe>
                                      <el-table-column
                                        prop="modelClassify"
                                        :label="$t('title.productCategories')"
                                        align="center"
                                        min-width="60px"
                                      > </el-table-column>
                                      <el-table-column
                                        prop="count"
                                        :label="$t('title.number')"
                                        align="center"
                                        min-width="60px"
                                      > </el-table-column>
                                    </el-table>
                                </div>
                                <div> {{ scope.row.Rotary }} </div>
                              </el-tooltip>
                            </template>
                          </el-table-column>
                          <el-table-column
                            prop="PAC"
                            label="PAC"
                            align="center"
                            min-width="60px"
                          >
                            <template slot-scope="scope">
                              <el-tooltip  placement="right-start">
                                <div slot="content" style="margin-left:100px; min-width:250px; overflow: auto; margin:10px;;max-height: 60vh;">
                                    <el-table :data="classifyNumObj[scope.row.name]?.PAC" stripe>
                                      <el-table-column
                                        prop="modelClassify"
                                        :label="$t('title.productCategories')"
                                        align="center"
                                        min-width="60px"
                                      > </el-table-column>
                                      <el-table-column
                                        prop="count"
                                        :label="$t('title.number')"
                                        align="center"
                                        min-width="60px"
                                      > </el-table-column>
                                    </el-table>
                                </div>
                                <div> {{ scope.row.PAC }} </div>
                              </el-tooltip>
                            </template>
                          </el-table-column>
                          <el-table-column
                            prop="BV"
                            label="BV"
                            align="center"
                            min-width="60px"
                          >
                            <template slot-scope="scope">
                              <el-tooltip  placement="right-start">
                                <div slot="content" style="margin-left:100px; min-width:250px; overflow: auto; margin:10px;max-height: 60vh;">
                                    <el-table :data="classifyNumObj[scope.row.name]?.BV" stripe>
                                      <el-table-column
                                        prop="modelClassify"
                                        :label="$t('title.productCategories')"
                                        align="center"
                                        min-width="60px"
                                      > </el-table-column>
                                      <el-table-column
                                        prop="count"
                                        :label="$t('title.number')"
                                        align="center"
                                        min-width="60px"
                                      > </el-table-column>
                                    </el-table>
                                </div>
                                <div> {{ scope.row.BV }} </div>
                              </el-tooltip>
                            </template>
                          </el-table-column>
                        </el-table>
                      </div>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="24" :lg="24">
                      <div class="homeCon homeConOpacity">
                        <h4 class="BoxTitle">
                          {{ translate["registration"] }}
                          <strong class="fr">{{ registerRate }}%</strong>
                        </h4>
                        <div id="registBar" :style="H2"></div>
                      </div>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="24" :lg="24">
                      <div class="homeCon homeConOpacity">
                        <h4 class="BoxTitle">
                          {{ translate["online"] }}
                          <strong class="fr">{{ onlineRate }}%</strong>
                        </h4>
                        <div id="onlineBar" :style="H3"></div>
                        <ul class="InstallTotal">
                          <li v-for="item in onlineTotal" :style="H3LineHeight">
                            <span class="name">{{ item.name }}</span>
                            <span class="num"
                              >{{ item.num }}<small>/</small>
                              {{ item.rate }}%</span
                            >
                          </li>
                        </ul>
                      </div>
                    </el-col>
                  </el-row>
                </el-col>

                <el-col :xs="24" :sm="24" :md="4" :lg="4" style="float: right">
                  <el-row>
                    <el-col :xs="24" :sm="24" :md="24" :lg="24">
                      <div class="homeCon homeConOpacity">
                        <h4 class="BoxTitle">
                          {{ translate["utilization"] }}

                          <strong class="fr">{{ utilizationRate }}%</strong>
                        </h4>
                        <h5 class="subTitle">{{ translate["lastmonth"] }}</h5>
                        <div id="UtilizationPie" :style="H4"></div>
                      </div>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="24" :lg="24">
                      <div
                        class="homeCon homeConOpacity"
                        style="padding: 20px 15px"
                      >
                        <h4 class="BoxTitle">
                          {{ translate["warning"] }}
                          <strong class="fr" style="color: rgb(252, 188, 93)">{{
                            warningCount
                          }}</strong>
                        </h4>
                        <div id="WarningPie" :style="H5"></div>
                      </div>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="24" :lg="24">
                      <div
                        class="homeCon homeConOpacity"
                        style="padding: 20px 15px"
                      >
                        <h4 class="BoxTitle">
                          {{ translate["trip"] }}
                          <strong class="fr" style="color: rgb(207, 85, 74)">{{
                            tripCount
                          }}</strong>
                        </h4>
                        <div id="TripPie" :style="H5"></div>
                      </div>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </el-col>
            <!-- <el-col :xs="24" :sm="4" :md="3" :lg="3">
              <div class="rightsideDiv">
                <div class="homeConNoBG">
                  <h4
                    class="BoxTitle"
                    style="text-align: left; max-width: 157px"
                  >
                    {{ translate["IotInsight"] }}
                  </h4>
                  <h5 class="subTitle">weekly</h5>

                  <el-carousel
                    :height="rightH.height"
                    :autoplay="false"
                    :interval="8000"
                    arrow="nerver"
                    indicator-position="outside"
                  >
                    <el-carousel-item
                      v-for="k in Math.ceil(
                        insightStatList.length / carouselNum
                      )"
                      :key="k"
                    >
                      <ul class="IotInsight">
                        <li
                          v-for="item in insightStatList.slice(
                            (k - 1) * carouselNum,
                            k * carouselNum
                          )"
                          :key="item.insightName"
                        >
                          <img
                            src="~assets/img/icon_Oil_Separat_or_Element.png"
                          />
                          <span
                            class="title"
                            :title="
                              activeLang == 'zh'
                                ? item.insightName
                                : item.insightEn
                            "
                            >{{
                              activeLang == "zh"
                                ? item.insightName
                                : item.insightEn
                            }}</span
                          >
                          <h4 class="num">
                            <a
                              target="_blank"
                              style="text-decoration: none; color: white"
                              >{{ item.count }}</a
                            >
                          </h4>
                        </li>
                      </ul>
                    </el-carousel-item>
                  </el-carousel>
                </div>
              </div>
            </el-col> -->
          </el-row>
        </el-main>
      </div>
    </el-container>
  </div>
</template>

<script type="text/javascript">
import * as echarts from "echarts";
import "assets/eCharts/world_new.js";
import {
  getShipmentStat,
  getRegistrationStat,
  getOnlineStat,
  getOfflineStat,
  getBaseStat,
  getWarnStat,
  getTripStat,
  getUtilizationStat,
  getMapStat,
  getInsightStat,
  getScreenDataStat,
  getScreenDevice
} from "../../api/api";
import { mapCoordinate } from "../../mixins/mapCoordinate";
import { multiTranslate } from "../../mixins/multiTranslate";
import { mapMutations, mapGetters } from "vuex";
import Pinyin from "js-pinyin"

export default {
  name: "Index",
  ...mapMutations(["setLanguage", "setMultiLanguage"]),
  mixins: [mapCoordinate, multiTranslate],
  data() {
    return {
      translate: {},
      rightH: {
        height: "",
        minHeight: "587px",
      },
      mapHeight: {
        height: "",
        minHeight: "645px",
      },
      H1Table: {
        height: "",
        minHeight: "110px",
        width: "100%",
        borderRadius: "12px",
        background: "#2f333b",
      },
      H1: {
        height: "",
        minHeight: "135px",
      },
      H2: {
        height: "",
        minHeight: "140px",
      },
      H3: {
        height: "",
        minHeight: "160px",
      },
      H3LineHeight: {
        lineHeight: "17px",
      },
      H4: {
        height: "",
        minHeight: "251px",
      },
      H5: {
        height: "",
        minHeight: "90px",
        marginBottom: "-20px",
      },
      carouselNum: 4,
      insightStatList: [],
      mapProvinceData: [],
      mapCityData: [],
      totalShipmentCount: 0,
      registerRate: 0,
      onlineRate: 0,
      offlineRate: 0,
      warningCount: 0,
      tripCount: 0,
      utilizationRate: 0,
      tableSend: [],
      registTotal: [],
      onlineTotal: [],
      offlineTotal: [],
      TripData: [],
      WarningData: [],
      UtlizationData: [],
      classifyNumObj: {},
    };
  },
  created: function () {
    //let lang = window.localStorage.getItem("multi_lang");
    let lang = window.localStorage.getItem("user_lang");
    if (!lang || lang == "zh") {
      this.translate = this.multiBrandZH;
      this.activeLang = "zh";
    } else if (lang == "en") {
      this.translate = this.multiBrandEn;
      this.activeLang = "en";
    }
    var that = this;
    that.getScreenDataStat();
    // that.getShipmentStat();
    // that.getRegistrationStat();
    // that.getOnlineStat();
    // that.getOfflineStat();
    // that.getBaseStat();
    // that.getWarnStat();
    // that.getTripStat();
    // that.getUtilizationStat();
    // that.getMapStat();
    that.getInsightStat();
    this.$nextTick(() => {
      that.SetMapHeight();
    });

    window.addEventListener("resize", this.SetMapHeight);
  },

  methods: {
    ...mapMutations(["setLanguage", "setMultiLanguage"]),
    changeLanguage(e) {
      //window.localStorage.setItem("multi_lang", e);
      window.localStorage.setItem("user_lang", e);
      this.setLanguage(e);
      window.location.reload();
    },
    SetMapHeight() {
      var WH = document.documentElement.clientHeight;
      var HTime = parseInt((WH - 290) / 19);
      this.H1.height = HTime * 5 + "px";
      this.H1Table.height = HTime * 5 - 50 + "px";
      this.H2.height = HTime * 6 + "px";
      this.H3.height = HTime * 8 + "px";
      if ((HTime * 8) / 6 - 16 > 11) {
        this.H3LineHeight.lineHeight = (HTime * 8) / 6 - 16 + "px";
      } else {
        this.H3LineHeight.lineHeight = "11px";
      }
      this.H4.height = HTime * 10.5 + "px";
      this.H5.height = HTime * 4 + "px";
      this.mapHeight.height = WH - 110 + "px";
      this.rightH.height = WH - 110 - 61 + "px";
      this.carouselNum = (WH - 110 - 61) / 145;
    },
    async getScreenDataStat(){
      let that = this;
      let res = await getScreenDataStat();
      let data = res.result;
      that.totalShipmentCount = data.shipmentCount;
      that.tableSend.push({
        "name": "China",
        "PAC": data.shipmentStats.find(a=>a.productLine.toLowerCase() == "pac" && a.region == "China")?.value??0,
        "Rotary": data.shipmentStats.find(a=>a.productLine.toLowerCase() == "rotary" && a.region == "China")?.value??0,
        "BV": data.shipmentStats.find(a=>a.productLine.toLowerCase() == "bv" && a.region == "China")?.value??0,
      })
      that.tableSend.push({
        "name": "RoAP",
        "PAC": data.shipmentStats.find(a=>a.productLine.toLowerCase() == "pac" && a.region == "RoAP")?.value??0,
        "Rotary": data.shipmentStats.find(a=>a.productLine.toLowerCase() == "rotary" && a.region == "RoAP")?.value??0,
        "BV": data.shipmentStats.find(a=>a.productLine.toLowerCase() == "bv" && a.region == "RoAP")?.value??0,
      });
      that.classifyNumObj["China"] = {
        "PAC": data.classifyStats.filter(a=>a.productLine.toLowerCase() == "pac" && a.region == "China")??[],
        "Rotary": data.classifyStats.filter(a=>a.productLine.toLowerCase() == "rotary" && a.region == "China")??[],
        "BV": data.classifyStats.filter(a=>a.productLine.toLowerCase() == "bv" && a.region == "China")??[],
      }
      that.classifyNumObj["RoAP"] = {
        "PAC": data.classifyStats.filter(a=>a.productLine.toLowerCase() == "pac" && a.region == "RoAP")??[],
        "Rotary": data.classifyStats.filter(a=>a.productLine.toLowerCase() == "rotary" && a.region == "RoAP")??[],
        "BV": data.classifyStats.filter(a=>a.productLine.toLowerCase() == "bv" && a.region == "RoAP")??[],
      }
      console.log(that.classifyNumObj);
      that.registerRate = data.registerRate;
      that.registTotal = data.registerStats;
      let dateList = data.registerStats[0]?.date;
      that.initLine(dateList);

      that.onlineRate = data.onlineRate;
      that.onlineTotal = data.onlineStats;

      that.utilizationRate = data.utilizationRate
      let productLineArr = that.unique(data.utilizationStats.map(a=>a.productLine));
      for (let index = 0; index < productLineArr.length; index++) {
        const element = productLineArr[index];
        let curU = new Object();
        curU.name = element;
        curU.children = data.utilizationStats.filter(a=>a.productLine == element).map(a=> {return {
          name: a.name, value: a.rate
        }})
        that.UtlizationData.push(curU);
      }
      that.initUtilizationPie();

      that.warningCount = data.warningCount;
      that.WarningData = data.warningStats;
      that.initAlertPie("WarningPie", that.WarningData, "Warning", 0);

      that.tripCount = data.tripCount;
      that.TripData = data.tripStats;
      that.initAlertPie("TripPie", that.TripData, "Trip", 1);

      that.mapProvinceData = data.screenMapList;
      that.mapCityData = [];
      if (
        that.mapProvinceData != "" &&
        that.mapProvinceData != undefined &&
        that.mapProvinceData != null
      ) {
        that.mapProvinceData.forEach(function (item) {
          if (item != "" && item != undefined && item != null) {
            item.value.forEach(function (value) {
              that.mapCityData.push(value);
            });
          }
        });
      }
      that.initMap();

    },
    async getShipmentStat() {
      let that = this;
      let res = await getShipmentStat();
      let data = res.result;
      that.tableSend = data;
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        for (let key in element) {
          const elementCount = element[key];
          if (key != "name") {
            that.totalShipmentCount += elementCount;
          }
        }
      }
    },
    async getRegistrationStat() {
      let that = this;
      let res = await getRegistrationStat();
      this.registTotal = res.result;
      let dateList = res.result[0]?.date;
      that.initLine(dateList);
    },
    async getOnlineStat() {
      let that = this;
      let res = await getOnlineStat();
      that.onlineTotal = res.result;
      that.initBar("onlineBar", "Total online", that.onlineTotal);
    },
    async getOfflineStat() {
      let that = this;
      let res = await getOfflineStat();
      that.offlineTotal = res.result;
      that.initBar("offlineBar", "Total offline", that.offlineTotal);
    },
    async getBaseStat() {
      let that = this;
      let res = await getBaseStat();
      that.registerRate = res.result.registerRate;
      that.onlineRate = res.result.onlineRate;
      that.offlineRate = res.result.offlineRate;
      that.utilizationRate = res.result.utilizationRate;
    },
    async getWarnStat() {
      let that = this;
      let res = await getWarnStat();
      that.WarningData = res.result;
      that.warningCount = res.result.reduce((x, y) => {
        return (x += y.value);
      }, 0);
      that.initAlertPie("WarningPie", that.WarningData, "Warning", 0);
    },
    async getTripStat() {
      let that = this;
      let res = await getTripStat();
      that.TripData = res.result;
      that.tripCount = res.result.reduce((x, y) => {
        return (x += y.value);
      }, 0);
      that.initAlertPie("TripPie", that.TripData, "Trip", 1);
    },
    async getUtilizationStat() {
      let that = this;
      let res = await getUtilizationStat();
      let data = res.result;
      that.UtlizationData = data;
      that.initUtilizationPie();
    },
    async getMapStat() {
      let that = this;
      let res = await getMapStat();
      that.mapProvinceData = res.result;
      that.mapCityData = [];
      if (
        that.mapProvinceData != "" &&
        that.mapProvinceData != undefined &&
        that.mapProvinceData != null
      ) {
        that.mapProvinceData.forEach(function (item) {
          if (item != "" && item != undefined && item != null) {
            item.value.forEach(function (value) {
              that.mapCityData.push(value);
            });
          }
        });
      }
      that.initMap();
    },
    retHome() {
      //this.$router.push({ path: "/index" });      
      window.location.href="/index";
    },
    async getInsightStat() {
      let that = this;
      let res = await getInsightStat();
      that.insightStatList = res.result;
    },
    unique(arr) {//去重
      const res = new Map();
      return arr.filter((a) => !res.has(a) && res.set(a, 1));
    },
    initMap() {
      // 获取echarts的容器
      let that = this;
      var chart = echarts.init(document.getElementById("map"));
      var geoCoordMap = JSON.parse(JSON.stringify(this.mapCoordinate));
      var ProvinceData = this.mapProvinceData; //省级标点数据
      var CityData = this.mapCityData; //市级标点数据

      // var Singaporetemp = {
      //   //亚太的数据格式（省级）
      //   name: "New Zealand",
      //   value: [
      //     {
      //       name: "New Zealand",
      //       value: 10,
      //     },
      //   ],
      // };
      // var Philippinestemp = {
      //   //亚太的数据格式（市级）
      //   name: "Philippines",
      //   value: 0,
      // };

      // ProvinceData.push(Singaporetemp);
      // CityData.push(Philippinestemp);

      var ProvinceName = [
        "河北",
        "山西",
        "辽宁",
        "吉林",
        "黑龙江",
        "江苏",
        "浙江",
        "安徽",
        "福建",
        "江西",
        "山东",
        "河南",
        "湖北",
        "湖南",
        "广东",
        "海南",
        "四川",
        "贵州",
        "云南",
        "陕西",
        "甘肃",
        "青海",
        "中国台湾",
        "内蒙古",
        "广西",
        "宁夏",
        "西藏",
        "新疆",
        "北京",
        "天津",
        "上海",
        "重庆",
        "香港",
        "澳门",
        "Singapore",
        "Philippines",
      ];

      var regions = [
        //对不同的区块进行着色
        {
          name: "China",
          itemStyle: {
            areaColor: "rgba(40, 115, 154, 1)",
          },
        },
        {
          name: "Singapore",
          itemStyle: {
            areaColor: "rgba(40, 115, 154, 1)",
          },
        },
        {
          name: "Malaysia",
          itemStyle: {
            areaColor: "rgba(40, 115, 154, 1)",
          },
        },
        {
          name: "Indonesia",
          itemStyle: {
            areaColor: "rgba(40, 115, 154, 1)",
          },
        },
        {
          name: "Thailand",
          itemStyle: {
            areaColor: "rgba(40, 115, 154, 1)",
          },
        },
        {
          name: "Philippines",
          itemStyle: {
            areaColor: "rgba(40, 115, 154, 1)",
          },
        },
        {
          name: "Vietnam",
          itemStyle: {
            areaColor: "rgba(40, 115, 154, 1)",
          },
        },
        {
          name: "Korea",
          itemStyle: {
            areaColor: "rgba(40, 115, 154, 1)",
          },
        },
        {
          name: "Australia",
          itemStyle: {
            areaColor: "rgba(40, 115, 154, 1)",
          },
        },
        {
          name: "New Zealand",
          itemStyle: {
            areaColor: "rgba(40, 115, 154, 1)",
          },
        },
        {
          name: "Japan",
          itemStyle: {
            areaColor: "rgba(40, 115, 154, 1)",
          },
        },
        {
          name: "Brunei",
          itemStyle: {
            areaColor: "rgba(40, 115, 154, 1)",
          },
        },
        {
          name: "Cambodia",
          itemStyle: {
            areaColor: "rgba(40, 115, 154, 1)",
          },
        },
        {
          name: "Lao PDR",
          itemStyle: {
            areaColor: "rgba(40, 115, 154, 1)",
          },
        },
        {
          name: "Guam",
          itemStyle: {
            areaColor: "rgba(40, 115, 154, 1)",
          },
        },
        {
          name: "Fiji",
          itemStyle: {
            areaColor: "rgba(40, 115, 154, 1)",
          },
        },
        {
          name: "Papua New Guinea",
          itemStyle: {
            areaColor: "rgba(40, 115, 154, 1)",
          },
        },
        {
          name: "Palau",
          itemStyle: {
            areaColor: "rgba(40, 115, 154, 1)",
          },
        },
        {
          name: "Solomon Is.",
          itemStyle: {
            areaColor: "rgba(40, 115, 154, 1)",
          },
        },
        {
          name: "Timor-Leste",
          itemStyle: {
            areaColor: "rgba(40, 115, 154, 1)",
          },
        },
        {
          name: "Tonga",
          itemStyle: {
            areaColor: "rgba(40, 115, 154, 1)",
          },
        },
        {
          name: "Vanuatu",
          itemStyle: {
            areaColor: "rgba(40, 115, 154, 1)",
          },
        },
        {
          name: "Samoa",
          itemStyle: {
            areaColor: "rgba(40, 115, 154, 1)",
          },
        },
      ];
      ProvinceName.forEach(function (item) {
        var temp = {
          name: that.translateResourceType(item),
          itemStyle: {
            areaColor: "rgba(40, 115, 154, 1)",
          },
        };
        regions.push(temp);
      });

      var ProvinceSeries = [];
      var CitySeries = [];

      function ProvinceFunciton(data) {
        var temp = [];
        [[, data]].forEach(function (item, i) {
          temp.push({
            type: "effectScatter",
            coordinateSystem: "geo",
            zlevel: 2,
            rippleEffect: {
              //涟漪特效
              period: 2, //动画时间，值越小速度越快
              brushType: "stroke", //波纹绘制方式 stroke, fill
              scale: 2.5,
              //波纹圆环最大限制，值越大波纹越大
              color: "rgba(255,255,255,0.8)",
            },
            itemStyle: {
              color: "rgba(255,255,255,1)",
              borderColor: "rgba(255,242,77, 0.8)",
            },
            label: {
              normal: {
                show: true,
                position: "right", //显示位置
                offset: [5, 0], //偏移设置
                formatter: "", //圆环显示文字
              },
              emphasis: {
                show: true,
              },
            },
            symbol: "circle",
            symbolSize: function (val) {
              var level = 0;
              if (val != "" && val != undefined && val != null) {
                var value = val.slice(2, val.length);
                let total = value.reduce((x, y) => {
                  return (x += y.value);
                }, 0);

                var state = Math.floor(total / 150);
                if (state < 10) {
                  level = state;
                } else {
                  level = 10;
                }
              }
              return level + 2; //圆环大小
            },

            data: item[1].map(function (dataItem) {
              return {
                name: dataItem.name /*+"\n"+dataItem[0].value*/,
                value:
                  geoCoordMap[dataItem.name] == null
                    ? ""
                    : geoCoordMap[dataItem.name].concat(dataItem.value),
              };
            }),
            tooltip: {
              show: true,
              showDelay: 0,
              hideDelay: 500,
              formatter: function (params, ticket, callback) {
                //根据业务自己拓展要显示的内容
                var res = "";
                var name = params.name;
                var value = params.value.slice(2, params.value.length);
                let total = value.reduce((x, y) => {
                  return (x += y.value);
                }, 0);
                res =
                  "<div style='padding-right:12px;color:#fff;max-height:260px;overflow:auto;display:block;line-height: 22px;'><h5 style='margin:0;font-weight:bold;font-size:14px;margin-bottom:8px'>" +
                  that.translateResourceType(name) +
                  ": " +
                  total +
                  "</h5>";
                for (let index = 0; index < value.length; index++) {
                  const element = value[index];
                  if (element.name == params.name) {
                  } else {
                    res += that.translateResourceType(element.name) + " : " + element.value + "<br>";
                  }
                }
                return res;
                res += "</div>";
              },
            },
          });
        });
        return temp;
      }
      //var series = [];
      function CityFunciton(data) {
        var temp = [];
        [[, data]].forEach(function (item, i) {
          temp.push({
            type: "effectScatter",
            coordinateSystem: "geo",
            zlevel: 4,
            rippleEffect: {
              //涟漪特效
              period: 2, //动画时间，值越小速度越快
              brushType: "stroke", //波纹绘制方式 stroke, fill
              scale: 2.5,
              //波纹圆环最大限制，值越大波纹越大
              color: "rgba(255,255,255,0.8)",
            },
            itemStyle: {
              color: "rgba(255,255,255,1)",
              borderColor: "rgba(255,242,77, 0.8)",
            },
            label: {
              normal: {
                show: true,
                position: "right", //显示位置
                offset: [5, 0], //偏移设置
                formatter: "", //圆环显示文字
              },
              emphasis: {
                show: true,
              },
            },
            symbol: "circle",
            symbolSize: function (val) {
              var level = 0;
              if (val != "" && val != undefined && val != null) {
                var state = Math.floor(val[2] / 50);
                if (state < 10) {
                  level = state;
                } else {
                  level = 10;
                }
              }
              return level + 4; //圆环大小
            },

            data: item[1].map(function (dataItem) {
              return {
                name: dataItem.name /*+"\n"+dataItem[0].value*/,
                value:
                  geoCoordMap[dataItem.name] == null
                    ? ""
                    : geoCoordMap[dataItem.name].concat(dataItem.value),
              };
            }),
            tooltip: {
              show: true,
              showDelay: 0,
              hideDelay: 0,
              formatter: function (params, ticket, callback) {
                //根据业务自己拓展要显示的内容
                var res = "";
                var name = params.name;
                var value = params.value[2];

                res =
                  "<div style='padding-right:12px;color:#fff;max-height:260px;overflow:auto;display:block;line-height: 22px;'><h5 style='margin:0;font-weight:bold;font-size:14px;'>" +
                  that.translateResourceType(name) +
                  " : " +
                  value +
                  "</h5>";

                res += "</div>";
                return res;
              },
            },
          });
        });
        return temp;
      }

      var mWidth = document.documentElement.clientWidth;
      var mHeight = document.documentElement.clientHeight;
      // var step = 37 + ((mHeight / mWidth) * 100 - 56);
      var mleft = "";
      var mtop = "";

      //mleft = -8 - (mHeight - 657) / 10 - 1 + "%";
      mleft = -(80 - ((mWidth / mHeight) * 72) / 1.98) + "%";
      //mleft = "-35%";
      mtop = "60%";

      var option = {
        tooltip: {
          trigger: "item",
          backgroundColor: "rgba(0,0,0,0.8)",
          borderColor: "rgba(255,255,255,0)",
          textStyle: {
            color: "#fff",
            fontSize: 12,
            fontFamily: "Arial",
          },
          showDelay: 0,
          hideDelay: 500,
          enterable: true,
          transitionDuration: 0,
          extraCssText: "z-index:100",
          confine: true,
          renderMode: "html",
          formatter: function (params, ticket, callback) {
            //根据业务自己拓展要显示的内容
            var res = "";
            var name = params.name;
            var value = params.value.slice(2, params.value.length);
            let total = value.reduce((x, y) => {
              return (x += y.value);
            }, 0);
            res =
              "<div style='padding-right:12px;color:#fff;max-height:260px;overflow:auto;display:block;line-height: 22px;'><h5 style='margin:0;font-weight:bold;font-size:14px;margin-bottom:8px'>" +
              that.translateResourceType(name) +
              ": " +
              total +
              "</h5>";
            for (let index = 0; index < value.length; index++) {
              const element = value[index];
              res += that.translateResourceType(element.name) + " : " + element.value + "<br>";
            }
            res += "</div>";
            return res;
          },
        },
        // visualMap: {
        //   //图例值控制
        //   min: 0,
        //   max: 10000,
        //   text: ["High", "Low"],
        //   show: false,
        //   calculable: true,
        //   //color: ["#0bc7f3"],
        //   color: ["orangered", "yellow", "lightskyblue"],
        // },
        geo: {
          map: "world",
          label: {
            emphasis: {
              show: true,
              color: "rgba(255,255,255,0.5)",
            },
            formatter: function (params, ticket, callback) {
            //根据业务自己拓展要显示的内容
            var res = that.translateResourceType(params.name);
            return res;
          },
          },
          roam: true, //是否允许缩放
          zoom: 4,
          layoutCenter: [mleft, mtop], //地图位置
          layoutSize: "100%",
          itemStyle: {
            areaColor: "rgba(41,111,203,0 )",
            borderColor: "#7CC9F0",
            emphasis: {
              color: "#212733", //悬浮背景
            },
          },
          regions: regions,
          tooltip: {
            show: false,
          },
        },
        series: ProvinceFunciton(ProvinceData),
      };
      chart.setOption(option);

      window.addEventListener("resize", () => {
        chart.resize();
      });
      chart.on("georoam", function (params) {
        var zoom = chart.getOption().geo[0].zoom;

        if (zoom > 12) {
          var temp = {
            series: CityFunciton(CityData),
          };
          chart.setOption(temp);
        } else {
          var temp = {
            series: ProvinceFunciton(ProvinceData),
          };
          chart.setOption(temp);
        }
      });
    },
    initBar(id, name, data) {
      var that = this;
      var RateData = [];
      var nameDate = [];
      for (let i = 0; i < data.length; i++) {
        nameDate.push(data[i].name);
        RateData.push(data[i].rate);
      }

      // 获取echarts的容器
      var chart = echarts.init(document.getElementById(id));
      var option = {
        grid: {
          left: 0,
          right: 0,
          bottom: 0,
          top: 0,
        },
        xAxis: {
          type: "value",
          max: 100,
          axisLabel: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          splitLine: {
            show: false,
          },
        },
        yAxis: {
          type: "category",
          inverse: true,
          data: nameDate,
          axisLabel: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          splitLine: {
            show: false,
          },
        },
        series: [
          {
            name: name,
            type: "bar",
            barCategoryGap: "40%",
            data: RateData,
            showBackground: true,
            backgroundStyle: {
              color: "#30333B",
            },
            itemStyle: {
              borderRadius: [0, 10, 10, 0],
              color: new echarts.graphic.LinearGradient(0, 1, 1, 0, [
                { offset: 0, color: "#00759B" },
                { offset: 1, color: "#1A3B46" },
              ]),
            },
          },
        ],
      };
      chart.setOption(option);

      window.addEventListener("resize", () => {
        chart.resize();
      });
    },
    initLine(date) {
      var timeLine = date;
      var series = [];
      for (var i = 0; i < this.registTotal.length; i++) {
        series.push({
          name: this.registTotal[i].name,
          type: "line",
          smooth: true, //是否平滑
          showSymbol: false,
          symbolSize: 2,
          lineStyle: {
            normal: {
              // color: "#28739A",
            },
          },
          itemStyle: {
            // color: "#28739A",
            // borderColor: "#28739A",
            borderWidth: 2,
          },
          emphasis: {
            focus: "series",
          },
          data: this.registTotal[i].value,
        });
      }
      // 获取echarts的容器
      var chart = echarts.init(document.getElementById("registBar"));
      var option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
          position: "top",
          backgroundColor: "#141518", // 提示背景颜色，默认为透明度为0.7的黑色
          borderColor: "rgba(0,0,0,0)",
          textStyle: {
            color: "#fff",
            fontSize: 12,
            fontFamily: "Arial",
          },
        },
        grid: {
          top: 20,
          left: 40,
          right: 10,
          bottom: 25,
        },
        xAxis: {
          type: "category",
          splitLine: {
            show: false,
          },
          axisLabel: {
            show: true,
            color: "#828393",
            textStyle: {
              fontSize: 10,
              fontFamily: "Arial",
            },
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          boundaryGap: false,
          data: timeLine,
        },
        yAxis: {
          max: 100,
          type: "value",
          splitNumber: 5,
          splitLine: {
            show: false,
          },
          axisLabel: {
            show: true,
            color: "#828393",
            textStyle: {
              fontSize: 10,
              fontFamily: "Arial",
            },
            formatter: "{value}%",
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
        },
        series: series,
      };
      chart.setOption(option);

      window.addEventListener("resize", () => {
        chart.resize();
      });
    },
    initAlertPie(id, data, name, type) {
      let tatalCount = data.reduce((x, y) => {
        return (x += y.value);
      }, 0);
      var color = [];
      if (type) {
        //type：1是trip;  2是warning
        color = "#CF554A";
      } else {
        color = "#FCBC5D";
      }

      data = data.map((item) => {
        return {
          region: item.region,
          productLine: item.productLine,
          name: item.name,
          value: item.value,
          itemStyle: {
            color: color,
          },
        };
      });
      // 获取echarts的容器
      var chart = echarts.init(document.getElementById(id));
      var option = {
        tooltip: {
          trigger: "item",
          formatter: (param) => {
            if (param.name) {
              return (
                param.seriesName +
                "<br>" +
                param.marker +
                "<strong>" +
                param.value +
                "</strong>" +
                "&nbsp&nbsp&nbsp&nbsp" +
                param.name +
                "&nbsp&nbsp&nbsp&nbsp" +
                ((param.value / tatalCount) * 100).toFixed(2) +
                "%"
              );
            } else {
              return "";
            }
          },

          backgroundColor: "#141518", // 提示背景颜色，默认为透明度为0.7的黑色
          borderColor: "rgba(0,0,0,0)",
          textStyle: {
            color: "#fff",
            fontSize: 12,
            fontFamily: "Arial",
          },
        },
        visualMap: {
          show: false,
          // min: 80,
          // max: 600,
          inRange: {
            colorLightness: [0.6, 0.2],
          },
        },
        series: [
          {
            name: name,
            type: "pie",
            radius: "70%",
            center: ["50%", "45%"],
            // avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            // emphasis: {
            //   label: {
            //     show: true,
            //     fontSize: "16",
            //     fontWeight: "bold",
            //   },
            // },
            labelLine: {
              show: false,
            },
            data: data.sort(function (a, b) {
              return a.value - b.value;
            }),
            // roseType: "radius",
            itemStyle: {
              color: color,

              shadowBlur: 15,
              shadowColor: "rgba(0,0,0,0.5)",
            },
            animationType: "scale",
            animationEasing: "elasticOut",
            animationDelay: function (idx) {
              return Math.random() * 200;
            },
          },
          {
            type: "pie",
            center: ["50%", "45%"],
            radius: "90%",
            hoverAnimation: false,
            data: [100],
            cursor: "default",
            label: {
              show: false,
            },
            labelLine: {
              show: false,
            },
            itemStyle: {
              normal: {
                color: "rgba(255,255,255,0.2)",
              },
            },
            tooltip: {
              show: false,
            },
            emphasis: {
              cursor: "default",
            },
            z: -1,
          },
        ],
      };
      chart.setOption(option);

      window.addEventListener("resize", () => {
        chart.resize();
      });
    },
    initUtilizationPie() {
      var that = this;
      var series = [];
      for (var i = 0; i < this.UtlizationData.length; i++) {
        var left = "0%";
        var top = "0%";
        var pieName = ["Rotary", "PAC", "BV"];
        switch (i) {
          case 0:
            left = "30%";
            top = "20%";
            break;
          case 1:
            left = "70%";
            top = "48%";
            break;
          case 2:
            left = "30%";
            top = "75%";
            break;
        }
        var radius1 = 55;
        var radius2 = 65;
        const curUtlization = this.UtlizationData.find(a=>a.name == pieName[i])
        for (var j = 0; j < curUtlization.children.length; j++) {
          radius1 -= 18;
          radius2 -= 18;
          series.push({
            name:
            curUtlization.name + that.translate["UtilizationRate"],
            type: "pie",
            radius: [radius1 + "%", radius2 + "%"],
            center: [left, top],
            avoidLabelOverlap: false,
            clockwise: false,
            label: {
              show: false,
            },
            labelLine: {
              show: false,
            },
            data: [
              {
                name: curUtlization.children[j].name,
                value: curUtlization.children[j].value,
              },
              {
                name: "",
                value: 100 - curUtlization.children[j].value,
                itemStyle: { color: "#30333B" },
              },
            ],
            zlevel: 2,
          });
        }
        series.push({
          name: pieName[i],
          type: "pie",
          radius: [0, "58%"],
          center: [left, top],
          avoidLabelOverlap: false,
          clockwise: false,
          label: {
            show: true,
            position: "inside",
            fontSize: "14",
            fontWeight: "bold",
            formatter: ["{top|}", "{titleStyle|" + pieName[i] + "}"].join("\n"),
            rich: {
              top: {
                height: "55",
              },
              titleStyle: {
                color: "#fff",
                paddingTop: 100,
              },
            },
          },
          labelLine: {
            show: false,
          },
          data: [
            { name: "", value: 100, itemStyle: { color: "rgba(0,0,0,0.1)" } },
          ],
          tooltip: {
            show: false,
          },
        });
      }
      // 获取echarts的容器
      var chart = echarts.init(document.getElementById("UtilizationPie"));
      var option = {
        color: [
          "#28739A",
          "#529BC1",
          "#4BC4EA",
          "#1576B9",
          "#62BCED",
          "#5FBFFF",
          "#39627E",
        ],
        tooltip: {
          trigger: "item",
          formatter: (param) => {
            if (param.name) {
              return (
                param.seriesName +
                "<br>" +
                param.marker +
                param.name +
                "&nbsp&nbsp&nbsp&nbsp" +
                param.value +
                "%"
              );
            } else {
              return "";
            }
          },
          valueFormatter: (value) => value + "%",
          backgroundColor: "#141518", // 提示背景颜色，默认为透明度为0.7的黑色
          borderColor: "rgba(0,0,0,0)",
          textStyle: {
            color: "#fff",
            fontSize: 12,
            fontFamily: "Arial",
          },
        },

        series: series,
      };
      chart.setOption(option);

      window.addEventListener("resize", () => {
        chart.resize();
      });
    },
    translateResourceType(name){
      return this.$t('city.'+name).indexOf(".")>-1?name:this.$t('city.'+name)
    },
  },
};
</script>

<style lang="less" scope>
body {
  padding: 0;
  margin: 0;
  color: #fff;
}
.theme1 {
  .backHome {
    width: auto !important;
    //   height: 26px !important;
    padding: 0px 10px !important;
    font-size: 12px !important;
    //  //  line-height: 27px;
    //margin-top: 31px;
    // margin-left: 29px;
    background: rgba(255, 255, 255, 0.3) !important;
    i {
      color: #fff;
      margin-right: 5px;
    }
    span {
      margin: 0 !important;
      font-size: 13px !important;
      line-height: 25px !important;
      padding: 0;
      color: #fff;
    }
  }
  // .rightSide {
  //   top: 0;
  //   left: 0;
  // }

  .Large-Header {
    text-align: center;
    height: 90px !important;
    z-index: 2;
    img {
      height: 46px;
      margin: 16px 0 0 30px;
      float: left;
    }
    span {
      display: inline-block;
      font-size: 24px;
      font-weight: 600;
      margin-top: 15px;
      line-height: 45px;
      margin-left: -192px;
      margin-right: -258px;
      small {
        display: block;
        font-size: 12px;
        margin: 0;
        line-height: 14px;
        color: #828393;
      }
    }
  }
  .Large-index {
    padding-top: 90px !important;
  }
  .el-row {
    margin-left: -10px !important;
    margin-right: -10px !important;
  }
  .el-col {
    padding-left: 10px !important;
    padding-right: 10px !important;
  }
  .el-table--small {
    td,
    th {
      padding: 9px 2px;
    }
  }
  .el-table {
    .el-table__body {
      tr {
        td {
          border-radius: 0 !important;
          background-color: rgba(0, 0, 0, 0);
        }
      }
    }
    tr {
      border-radius: 0 !important;
      background-color: rgba(0, 0, 0, 0);
    }
    .cell {
      padding: 0 0px;
    }
    .strong {
      .cell {
        color: #fff;
        font-weight: bold;
      }
    }
  }
  .homeCon {
    padding: 12px 15px;
    border-radius: 8px;
    margin-bottom: 20px;
  }
  .InstallTotal {
    position: absolute;
    bottom: 12px;
    right: 20px;
    left: 20px;
    margin: 0;
    padding: 0;
    list-style: none;
    font-size: 12px;
    li {
      line-height: 14px;
      padding: 8px 0;
      span.name {
        display: inline-block;
        font-weight: bold;
        color: #fff;
        width: calc(100% - 120px);
      }
      span.num {
        display: inline-block;
        color: #fff;
        width: 120px;
        text-align: right;
        small {
          font-size: 12px;
          color: rgba(255, 255, 255, 0.5);
          margin: 0 5px;
        }
      }
    }
  }
  .HealthRateUl {
    margin: 0;
  }
  .rightsideDiv {
    border-left: 0;
  }
  .homeConNoBG {
    padding-left: 0px;
  }
  .Large-language {
    float: right;
    margin-top: 22px;
    .el-button {
      height: 22px;
      border: 0px;
      width: 74px;
      padding: 0;
      background: none;
      span {
        line-height: 20px;
        font-size: 12px;
        margin: 0;
      }
    }
    .el-button.selected {
      background-color: #00759b;
      span {
        color: #fff;
      }
    }
  }
  .homeConOpacity {
    background-color: rgba(36, 39, 49, 0.9);
  }
}
</style>
